module.exports = __webpack_public_path__ + "img/salespersonDingDan.f740bbcc.png";